import React from 'react';
import { Bot, ShieldAlert, Zap, TrendingUp } from 'lucide-react';

const AboutSection: React.FC = () => {
  return (
    <div className="mt-12 bg-slate-900/50 border border-slate-800 rounded-2xl p-6 md:p-8 no-print">
      <div className="flex items-center gap-3 mb-6">
        <Bot className="text-yellow-500" size={24} />
        <h2 className="text-2xl font-bold font-['Space_Grotesk'] text-white">About TT Lotto Plus Predictor</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-slate-400 text-sm leading-relaxed">
        <div className="space-y-6">
          <div className="space-y-2">
            <h3 className="text-slate-200 font-bold flex items-center gap-2">
              <Zap size={16} className="text-blue-400" />
              How it Works
            </h3>
            <p>
              This application retrieves recent Trinidad and Tobago NLCB Lotto Plus results and analyzes the history locally. Frequency counts, hot/cold numbers, common pairs, and balanced sampling are derived from the same draw data shown in the app.
            </p>
          </div>

          <div className="space-y-2">
            <h3 className="text-slate-200 font-bold flex items-center gap-2">
              <TrendingUp size={16} className="text-green-400" />
              What is the Confidence Score?
            </h3>
            <p>
              The <strong>Confidence Score</strong> is a pattern-fit indicator showing how strongly a generated set follows its selected strategy and the available history. 
            </p>
            <p className="text-xs opacity-80">
              It is not a probability of winning. Every valid lottery combination remains a chance outcome, regardless of its historical pattern score.
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="text-slate-200 font-bold flex items-center gap-2">
            <ShieldAlert size={16} className="text-red-400" />
            Disclaimer
          </h3>
          <div className="p-4 bg-red-900/10 border border-red-900/30 rounded-lg">
            <p className="mb-2">
              <strong>Lottery games are games of chance.</strong>
            </p>
            <p>
              The predictions generated by this tool are for entertainment purposes only. No AI or statistical model can guarantee a win. 
              Past performance does not guarantee future results.
            </p>
            <p className="mt-2 text-xs opacity-70">
              Please gamble responsibly. NLCB rules and regulations apply.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;